import React from 'react';
import { findDOMNode } from 'react-dom';
import { HocWrapper } from '../hoc-wrapper';

export default function withClickOutside<P, S>(
  Component: HocWrapper<P>,
): React.ComponentClass<P> {
  class WrappedComponent extends React.Component<P, S> {
    public static displayName = '';

    public wrappedInstance = null;
    public wrappedDomNode = null;

    public handleClickOutside = e => {
      if (!this.wrappedDomNode) {
        return;
      }

      const bounds = this.wrappedDomNode.getBoundingClientRect();
      const mouseX = e.clientX || e.pageX;
      const mouseY = e.clientY || e.pageY;

      const clickedInBounds =
        mouseX <= bounds.right &&
        mouseX >= bounds.left &&
        mouseY <= bounds.bottom &&
        mouseY >= bounds.top;

      if (
        !clickedInBounds &&
        typeof this.wrappedInstance.handleClickOutside === 'function'
      ) {
        this.wrappedInstance.handleClickOutside(e);
      }
    };

    public componentDidMount() {
      window.addEventListener('click', this.handleClickOutside, true);
    }

    public componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside, true);
    }

    public render() {
      const { ...props } = this.props as any;

      return (
        <Component
          {...props}
          ref={el => {
            this.wrappedInstance = el;
            this.wrappedDomNode = findDOMNode(el);
          }}
        />
      );
    }
  }

  const name = WrappedComponent.displayName || WrappedComponent.name;
  WrappedComponent.displayName = `withClickOutside(${name})`;

  return WrappedComponent;
}
